import BaseAPI from './base'

/**
 * API xử lí bài kiểm tra
 */

class SubmitExamAPI extends BaseAPI {}

export default new SubmitExamAPI('v1/submit-exam', 'SubmitExam')
